module.exports = __webpack_public_path__ + "assets_app/img/audio_forward.029485f5.svg";